import get from 'get-value';
export var getInputWidth = function getInputWidth(input) {
  return get(input, ['props', 'width']);
};